export const settingsActionTypes = {
    INSTALLER_SETTINGS : 'INSTALLER_SETTINGS',
    SET_SELECTED_SETTINGS : 'SET_SELECTED_SETTINGS',
    EDIT_INSTALLER_SETTINGS : 'EDIT_INSTALLER_SETTINGS',
    INSTALLER_SETTINGS_COUNTRIES : 'INSTALLER_SETTINGS_COUNTRIES'
}